
<div class="login_bg">
        <!-- Form Section Start -->
        <div class="inner_container"> 
            <div class="login_form_wrapper">
                <div class="login_form_bg"><a href="login" class="logo" title="ManpowerGroup logo"></a></div>
                <div class="login_form">
                    <div class="login_header_right">
                        <h1>{{'DIRECTTEXT' | translate}}</h1>
                        <div class="dropdown language_dropdown">
                        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
                            {{buttonText}}
                        </button>
                        <ul class="dropdown-menu dropdown-menu" aria-labelledby="dropdownMenuButton2">
                            <li><a class="dropdown-item {{isSelected == 'en'? 'active':''}}" href="javascript:void(0)" (click)="switchLanguage('en')">English</a></li>
                            <li><a class="dropdown-item {{isSelected == 'jp'? 'active':''}}" href="javascript:void(0)" (click)="switchLanguage('jp')">Japanese</a></li>
                        </ul>
                    </div>
                    </div>
                    <!-- Login form Start-->
                     <div class="blank">
                        <p>Sign in with Microsoft</p>
                        <button (click)="login()"  class="btn btn-primary login">{{'LOGINTEXT' | translate}}</button>
                        <p>&copy; {{"CopyRightTxt" | translate}}</p>
                     </div>
                    
                    <!-- Login form Start-->

                </div>
            </div>
        </div>
        <!-- Form Section End -->
</div>         


